import { FC } from "react";

import { useTimezoneDate } from "hooks/use-timezone-date";
import { ISignedDocInbox } from "../store";

interface IProps {
  inbox: ISignedDocInbox;
}

export const InboxLastChangeDate: FC<IProps> = ({ inbox }) => {
  const { formatDate } = useTimezoneDate();
  return (
    <div className="InboxLastChangeDate__last-changes">
      <div className="InboxLastChangeDate__last-changes-date">
        {formatDate(inbox.createdAt, "MMM dd, yyyy", true)}
      </div>
      <div className="InboxLastChangeDate__last-changes-time">
        {formatDate(inbox.createdAt, "hh:mm a")}
      </div>
    </div>
  );
};
